export default __webpack_public_path__ + "static/11-28f8eed025f3adb87103983299a32109.jpg";